




























































import { Component } from 'vue-property-decorator';
import { minLength, required, sameAs } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import AccountsService from '@/service/AccountsService';
import Base from '@/views/Base';
import { AxiosError } from 'axios';

@Component({})
export default class ResetPasswordModal extends Base {
  model = {
    newPassword: '',
    confirmNewPassword: ''
  };

  showFalseNewPassword = false;
  showNewPasswordUsedInPast = false;
  isModalVisible = false;

  @Validations()
  validation = {
    model: {
      newPassword: { required, minLength: minLength(8) },
      confirmNewPassword: { sameAs: sameAs(() => this.model.newPassword) }
    }
  };

  resetForm() {
    console.log('resetForm');
    this.model.newPassword = '';
    this.model.confirmNewPassword = '';
    this.showFalseNewPassword = false;
    this.showNewPasswordUsedInPast = false;
    this.$v.model.$reset();
  }

  async submit(event: Event) {
    event.preventDefault();
    this.$v.$touch();
    if (this.$v.$invalid) {
      return;
    }

    const model = {
      newPasswordPlain: this.model.newPassword,
      token: this.$route.query.token as string
    };

    try {
      await AccountsService.resetPassword(model);
      this.toast(this.t('modals.resetPassword.success'), 'success');
      this.isModalVisible = false;
      this.$router.replace('/login');
    } catch (err) {
      const error = err as AxiosError;

      if (error.response?.status === 404) {
        this.toast(this.t('modals.resetPassword.invalidToken'), 'danger');
        this.isModalVisible = false;
        this.$router.replace('/login');
        return;
      }

      const msg = this.errorMessage(error);
      if (msg.includes('newPasswordPlain: invalid passwordHash')) {
        this.showFalseNewPassword = true;
      }
      if (msg.includes('New password has already been used in the past')) {
        this.showNewPasswordUsedInPast = true;
      }
    }
  }
}
